import React from 'react';
import PropTypes from 'prop-types';
import SVGIcon from 'components/SVGIcon';
import './index.scss';
import { ReactComponent as IconArrow } from './icon-right-arrow.svg';

/*
 * Types definition
 */
const propTypes = {
    children: PropTypes.node.isRequired,
    callback: PropTypes.func.isRequired,
};

/*
 * Component
 */
function ListItem({ children, callback }) {
    return (
        <div
            role="button"
            className="list-item"
            onClick={callback}
            onKeyPress={callback}
            tabIndex="0"
        >
            <div className="content">
                {children}
            </div>
            <SVGIcon icon={IconArrow} />
        </div>
    );
}

ListItem.propTypes = propTypes;

export default ListItem;
